<!-- 巨量引擎计划 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- 当天统计数据 -->
		<div style="background-color: #eff1f7;padding: 15px 50px 15px 15px;margin-bottom: 15px;">
			<!-- 刷新 -->
			<div style="display: flex;align-items: center;margin-bottom: 10px;">
				<div style="font-size: 16px;font-weight: 700;margin-right: 20px;">当天统计</div>
				<div @click="RefreshButton('button')" style="display: flex;align-items: center;cursor: pointer;">
					<a-icon :spin="sync_true" style="color: #62A8EA;" type="sync" />
					<div style="color: #62A8EA;margin-left: 10px;">刷新</div>
				</div>
				
			</div>
			<!-- 数据内容 -->
			<div style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
				<div>
					<div class="day-data-e" >
						<div class="day-data-a" >{{sameDay[0].cn_plan_num || '-'}}</div>
						<div class="day-data-b">（ 昨日：{{sameDay[1].cn_plan_num || '-'}} ）</div>
					</div>
					<div class="day-data-c">
						有消耗的计划数
					</div>
				</div>
				
				<div>
					<div class="day-data-e" >
						<div class="day-data-a" >{{sameDay[0].cost || '-'}}</div>
						<div class="day-data-b">（ 昨日：{{sameDay[1].cost || '-'}} ）</div>
					</div>
					<div class="day-data-c">
						总消耗
					</div>
				</div>
				
				<div>
					<div class="day-data-e" >
						<div class="day-data-a" >{{sameDay[0].convert || '-'}}</div>
						<div class="day-data-b">（ 昨日：{{sameDay[1].convert || '-'}} ）</div>
					</div>
					<div class="day-data-c">
						总转化数
					</div>
				</div>
				
				<div>
					<div class="day-data-e" >
						<div class="day-data-a" >{{sameDay[0].avg_cost || '-'}}</div>
						<div class="day-data-b">（ 昨日：{{sameDay[1].avg_cost || '-'}} ）</div>
					</div>
					<div class="day-data-c">
						平均转化成本
					</div>
				</div>
				
				<div>
					<div class="day-data-e" >
						<div class="day-data-a" >{{sameDay[0].charge_money || '-'}}</div>
						<div class="day-data-b">（ 昨日：{{sameDay[1].charge_money || '-'}} ）</div>
					</div>
					<div class="day-data-c">
						总分成金额
					</div>
				</div>
				
				<div>
					<div class="day-data-e" >
						<!-- <div class="day-data-a" >{{sameDay[0] | dayToFixed}}%</div>
						<div class="day-data-b">（ 昨日：{{sameDay[1] | dayToFixed}}% ）</div> -->
						<div class="day-data-a" >{{sameDay[0].roi || '-'}}%</div>
						<div class="day-data-b">（ 昨日：{{sameDay[1].roi || '-'}}% ）</div>
					</div>
					<div class="day-data-c">
						ROI
					</div>
				</div>
			</div>
			
		</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<a-menu-item key="1"> <a-icon type="align-right" />开启</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />暂停</a-menu-item>
						<a-menu-item key="3"> <a-icon type="user-delete" />删除</a-menu-item>
						<a-menu-item key="5"> <a-icon type="align-right" />修改回传参数</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<div class="jl-screen-box">
				<a-button @click="custtom_visible = true" icon="unordered-list" >自定义列</a-button>
			</div>
			
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    {{type_button_text}}
					<a-menu slot="overlay" @click="handleMenuClickB">
						<a-menu-item key="1"> <a-icon type="align-right" />全部</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />只看有消耗</a-menu-item>
						<a-menu-item key="3"> <a-icon type="align-right" />只看有展示</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<!-- <div style="display: flex;align-items: center;padding-right: 10px;"> -->
				<div class="jl-screen-box">
					<a-range-picker style="width:200px;" @change="onChangeDate" :allowClear="false"
					:locale="locale" 
					:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
				</div>
				
				<div v-if="Object.keys(personChargeList).length > 0" class="jl-screen-box">
					<a-select
						mode="multiple" 
						style="min-width: 135px;max-width: 390px;"
						placeholder="请选择投手"
						@change="handleChangeA"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						:value="r_admin_id" 
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 150px;max-width: 390px;"
						placeholder="请选择书城频道"
						@change="handleChangeX"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option v-for="(item,index) in filterData.book_type.list" :key="item.key" :value="item.key">
						  {{item.value}}
						</a-select-option>
						<a-select-option value="-1">未设置</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 150px;"
						placeholder="请选择书城形式"
						@change="handleChangeY"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option value="1">加粉</a-select-option>
						<a-select-option value="2">快应用</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 160px"
						placeholder="请选择书城渠道"
						@change="handleChangeZ"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option v-for="(item,index) in filterData.channel_id.list" :key="item.key" :value="item.key">
						  {{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<jlAdvSelect ref="getAdvSelect" @handle-change="handleChangeB"></jlAdvSelect>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_adv_id_input" placeholder="账户ID搜索" allowClear style="width: 190px;"/>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						mode="multiple" 
						style="min-width: 200px;max-width: 600px;"
						placeholder="请选择广告组"
						:filter-option="false"
						@change="handleChangeC"
						:value="r_campaign_id" 
						:getPopupContainer="getsPopupContainer" 
						@popupScroll="popupScrollGGZ" 
						showSearch
						allowClear
						@search="selectGgzSearch"
						:not-found-content="ggz_fetching ? undefined : null" 
						@blur="ggzBlur"
					  >
						<a-spin v-if="ggz_fetching" slot="notFoundContent" size="small" />
						<a-select-option v-for="(item,index) in ggz_Select" :key="item.id" :value="item.campaign_id">
						  {{item.group_name}}
						</a-select-option>
						<a-select-option v-if="ggz_loading_more_hint" value="-0-">
							<div style="color:rgb(98, 168, 234)">加载更多中...</div>
							
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_campaign_id_input" placeholder="广告组ID搜索" allowClear style="width: 190px;"/>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						mode="multiple" 
						style="min-width: 200px;max-width: 600px;"
						placeholder="请选择广告计划"
						:filter-option="false"
						@change="handleChangeE"
						:getPopupContainer="getsPopupContainer" 
						@popupScroll="popupScroll_Plan" 
						showSearch
						allowClear
						@search="select_Plan_Search"
						:not-found-content="plan_fetching ? undefined : null" 
						@blur="planBlur"
					  >
						<a-spin v-if="plan_fetching" slot="notFoundContent" size="small" />
						<a-select-option v-for="(item,index) in plan_Select" :key="item.id" :value="item.plan_id">
						  {{item.plan_name}}
						</a-select-option>
						<a-select-option v-if="plan_loading_more_hint" value="-0-">
							<div style="color:rgb(98, 168, 234)">加载更多中...</div>
							
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_plan_id_input" placeholder="广告计划ID搜索" allowClear style="width: 190px;"/>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 160px"
						placeholder="请选择广告状态"
						@change="handleChangeF"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option v-for="(value,key) in conditionSelect.status" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 110px"
						placeholder="操作状态"
						@change="handleChangeG"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option v-for="(value,key) in conditionSelect.opt_status" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<a-button @click="searchButton('button')" :loading="search_button_loading" class="jl-screen-box" type="primary" icon="search">搜索</a-button>
				<a-button @click="exportButton()" class="jl-screen-box" type="primary">导出</a-button>
			<!-- </div> -->
		</div>
	</div>
	</div>
	
	<div style="">
		<JLjhTable @table-th-click="tableThClick" @click-Fzr="clickFzr" :rableTitle="rableTitle" 
		:tableShowData="tableShowData" :tableSumData="tableSumData" 
		:table_scroll_width="table_scroll_width" 
		:indeterminate="indeterminate" :checkAll="checkAll" :table_null_width="table_null_width"
		@click-All-Checkbox="onCheckAllChange" @click-Checkbox="onChangeCheckbox"
		@status-Checkbox="statusCheckbox" @set-Plan-Hcbl="setPlanHcbl" 
		@td-handle="tdHandle"></JLjhTable>
	</div>
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 批量设置负责人 -->
	<a-modal :visible="pl_modal" title="批量设置负责人" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的负责人</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择负责人"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
					:value="pl_value"
				  >
					<a-select-option v-for="(item,index) in filterData.op_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 150px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 12px;">{{item.label}}</div>
					<!-- <div style="color: red;cursor: pointer;">删除</div> -->
					<a-icon @click="delSelectAdmin(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的账号名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 130px;">{{item.adv_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 批量删除 -->
	<a-modal :visible="dl_modal" title="确认要删除这些吗？" okType="danger" width="700px"
	  okText="删除" cancelText="取消"
	  @ok="dlOk" @cancel="dlCancel" :confirmLoading="dl_loading">
	    <div style="">
			<div style="margin-bottom: 10px;">已选的删除项（广告计划名称）：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 15px;" class="">
					<div style="width: 80px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 195px;">{{item.plan_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	
	<!-- 回传比例相关侧边栏 -->
	<a-drawer
	  title="计划回传比例"
	  width="1000px"
	  placement="right"
	  :closable="false"
	  :visible="hc_visible"
	  @close="hcCloseDrawer"
	>
		<div v-if="h_type_pl == 0" class="form-cell-box">
			<div class="class-title">广告计划名称</div>
				
			<div style="font-size: 15px;">{{h_plan_name}}</div>
		</div>
		
		<div v-if="h_type_pl == 0" class="form-cell-box">
			<div class="class-title">广告计划ID</div>
				
			<div style="font-size: 15px;">{{h_plan_id}}</div>
		</div>
		
		<div v-if="h_type_pl == 1" class="form-cell-box" style="align-items: self-start;">
			<div class="class-title">批量选择的广告计划名称</div>
				
			<div>
				<div style="max-height: 240px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
					<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 11px;display: flex;align-items: center;margin-right: 10px;" class="">
						<!-- <div style="width: 70px;text-align: right;">{{item.plan_id}}</div>
						<span style="margin: 0 5px;"> — </span> -->
						<div style="width: 200px;">{{item.plan_name}}</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">设置方式</div>
			<div>
				<a-radio-group @change="hcRadioE" name="radioGroup" :value="h_report_per_type">
					<a-radio :value="2">
					  自定义回传序列
					</a-radio>
					<a-radio :value="1">
					  固定回传序列（老版本）
					</a-radio>
				  </a-radio-group>
			</div>
		</div>
		
		<template v-if="h_report_per_type == 2">
			<div class="form-cell-box">
				<div class="class-title">计划最低消耗金额</div>
				<div style="height: 33px;line-height: 33px;">
					<a-radio-group @change="hcRadioP" name="radioGroup" :value="h_cost_type">
						<a-radio :value="0">
						  不设置
						</a-radio>
						<a-radio :value="1">
						  设置
						</a-radio>
					</a-radio-group>
					<template v-if="h_cost_type == 1">
						<a-input-number v-model="h_cost" :min="0" />
					</template>
					<span style="margin-left: 15px;color: #8d8b8b;">说明：广告消耗金额 达到 设置值后，才会使用下方的自定义回传序列</span>
				</div>
			</div>
			
			<div class="form-cell-box" style="align-items: flex-start;">
				<div class="class-title">自定义回传序列</div>
				<div class="custom-report-drawer-box" style="flex: 1;">
					<div v-for="(itmm,indd) in hCustomData" :key="itmm.id" style="border: 1px solid #ccc;border-radius: 8px;padding: 30px 20px;margin-bottom: 15px;position: relative;">
						<div style="display: flex;align-items: center;margin-bottom: 25px;">
							<span>订单金额范围：</span>
							<div style="display: flex;align-items: center;">
								<a-input-number v-model="itmm.h_min_money" :min="0" :max="1000" />
								<span style="margin: 0 10px;">到</span>
								<a-input-number v-model="itmm.h_max_money" :min="0" :max="1000" />
								<span style="margin-left: 10px;">元</span>
								<span style="margin-left: 15px;color: #8d8b8b;">说明：包含左右金额</span>
							</div>
						</div>
						
						<div style="margin-bottom: 12px;display: flex;">
							<div style="margin-bottom: 5px;text-align: right;">付费1：注册当日首充：</div>
							<span style="width: 90px;"> 序列长度：{{itmm.h_order_per.length}} </span>
							<div @click="hcCustomHandleA(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								添加
							</div>
							<div @click="hcCustomHandleC(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								删除
							</div>
						</div>
						<div style="margin-bottom: 12px;display: flex;">
							<!-- <div style="margin-bottom: 5px;flex-shrink: 0;width: 150px;text-align: right;">下单回传序列：</div> -->
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(item,index) in itmm.h_order_per" :key="item.id">
									<a-popover placement="top" :getPopupContainer="getsPopupContainer">
										<template slot="content">
										  <span @click="hcCustomDelA(index,indd)" style="cursor: pointer;font-size: 12px;color: #1890ff;">删除</span>
										</template>
										<a-input-number v-model="item.value" size="small" style="width: 25px;margin-right: 10px;margin-bottom: 7px;" :min="0" :max="1" />
									 </a-popover>
								</div>
							</div>
						</div>
						
						<div style="margin-bottom: 12px;display: flex;">
							<div style="margin-bottom: 5px;flex-shrink: 0;text-align: right;">付费2：后补序列：</div>
							<span style="width: 90px;"> 序列长度：{{itmm.h_purcharse_day_per.length}} </span>
							<div @click="hcCustomHandleB(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								添加
							</div>
							<div @click="hcCustomHandleD(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								删除
							</div>
							<span style="margin-left: 15px;color: #8d8b8b;">注册当日首充用户，T0-T8范围内，付费1未回传的订单。建议都回传。</span>
						</div>
						<div style="display: flex;">
							<!-- <div style="margin-bottom: 5px;flex-shrink: 0;width: 150px;text-align: right;">付费回传序列：</div> -->
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(item,index) in itmm.h_purcharse_day_per" :key="item.id">
									<a-popover placement="top" :getPopupContainer="getsPopupContainer">
										<template slot="content">
										  <span @click="hcCustomDelB(index,indd)" style="cursor: pointer;font-size: 12px;color: #1890ff;">删除</span>
										</template>
										<a-input-number v-model="item.value" size="small" style="width: 25px;margin-right: 10px;margin-bottom: 7px;" :min="0" :max="1" />
									</a-popover>
								</div>
							</div>
						</div>
						
						<a-icon @click="hcDelCustom(indd)" style="font-size: 16px;position: absolute;right: 15px;top: 15px;cursor: pointer;color: rgba(0, 0, 0, 0.65);" type="close" />
					</div>
					
					<a-button @click="hcAddCustom" icon="plus" >新增订单范围</a-button>
				</div>
			</div>
			
		</template>
		
		<template v-else-if="h_report_per_type == 1">
			<div class="form-cell-box">
				<div class="class-title">回传最低金额(元)</div>
					
				<a-input-number @change='hcNumber($event,1)' :min="0" :max="100000" :value="h_report_money_limit" style="width: 130px;" />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">注册时间</div>
				
				<div>
					<a-radio-group @change="hcRadioA" name="radioGroup" :value="h_user_reg_time_condition">
						<a-radio :value="1">
						  只传注册当天用户
						</a-radio>
						<a-radio :value="0">
						  注册时间不限
						</a-radio>
					  </a-radio-group>
				</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">充值时间</div>
					
				<div>
					<a-radio-group @change="hcRadioB" name="radioGroup" :value="h_order_time_condition_type" style="width: 100%;">
						<a-radio :value="1">
							注册日期当天首次充值
						</a-radio>
						<a-radio :value="0" style="width: 260px;">
							<div style="display: inline-block;align-items: center;">
								注册后
								<a-input-number @change='hcNumber($event,2)' :min="0" :max="100000" :value="h_order_time_condition_n" style="width: 80px;margin: 0 5px;" />
								小时内首次充值
							</div>
						  
						</a-radio>
						
					  </a-radio-group>
				</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">回传比例</div>
					
				<a-input-number @change='hcNumber($event,3)' :min="0" :max="100000" :value="h_report_per"  style="width: 130px;" />
			</div>
		</template>
		
		<div class="form-cell-box">
			<div class="class-title">是否开启付费2</div>
			<div style="height: 33px;line-height: 33px;">
				<a-radio-group @change="hcRadioS" name="radioGroup" :value="h_is_supply_active_pay">
					<a-radio :value="0">
					  不开启
					</a-radio>
					<a-radio :value="1">
					  开启
					</a-radio>
				</a-radio-group>
			</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">是否启用</div> 
				
			<a-switch @change="hcDrawerSwitch" :checked="h_status" checked-children="启用" un-checked-children="暂停" />
		</div>
		
		<div style="color: red;height: 23px;margin-top: 35px;margin-bottom: -10px;margin-left: 40px;">{{hc_form_hint}}</div>
		
		<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
			<a-button @click="hcRequest" :loading="hc_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
			<a-button @click="hcCloseDrawer">取消</a-button>
		</div>

	</a-drawer>
	
	<!-- 小时统计 -->
	<JLjhHour ref="getDrawerHour" :page_type="'JLjh'" :show_name="h_plan_name" :show_id="h_plan_id"
	@hour-loading-handle="hourLoadingHandle" @hour-drawer-close="hourDrawerClose"></JLjhHour>
	<!-- 天统计 -->
	<JLjhDay ref="getDrawerDay" :page_type="'JLjh'" :show_name="h_plan_name" :show_id="h_plan_id"
	@hour-loading-handle="hourLoadingHandle" @hour-drawer-close="hourDrawerClose"></JLjhDay>
	
	
	<!-- 自定义列 -->
	<a-modal v-model="custtom_visible" width="830px" title="设置自定义列" @ok="customTd" @cancel="customTd" okText="确认" cancelText="取消" >
	    <div style="max-height:500px;overflow-y: overlay;">
			<template  v-for="(d_tem,d_ndex) in customCheckboxData">
				<div class="custom-title">
					<a-checkbox @change="checkboxCustom($event,d_tem)"
					:checked="d_tem.custom_checkbox" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
					{{d_tem.label}}
				</div>
				<div class="custom-cell-box">
					<template v-for="(item,index) in rableTitle">
						<div v-if="(d_tem.showTitle.indexOf(item.type) > -1)" 
						:key="item.type" style="width:240px;">
							<a-checkbox @change="onChangeSJ($event,index,d_tem)"
							:checked="item.show_control" style="margin-right: 5px;margin-bottom:7px;">
								{{item.title}}
							</a-checkbox>
						</div>
					</template>
				</div>
			</template>
			
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { JLjhList, putDataMenu, putSetAdvUser, JLggzSelectGroup, JLjhEditStatus, JLjhSelectStatus, putUserList, JLjhSelectPlan, JLjhPlanDate, JLjhReportConfig, JLjhPlReportConfig, JLjhExport } from '@/request/api'
import JLjhTable from '@/components/JLtable/JLjhTable.vue'
import JLjhHour from '@/components/JLtable/JLjhHour.vue'
import JLjhDay from '@/components/JLtable/JLjhDay.vue'
import jlAdvSelect from './components/jlAdvSelect.vue'
export default {
	name: 'JLjh_',
	components: {
		JLjhTable, JLjhHour, JLjhDay, jlAdvSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			s_limit: 100,
			
			// 广告组
			ggz_Select: [], // 选择广告组
			ggz_Blur: [], // 保存一份，用于失去焦点后，回复原来的数值
			ggz_page: 1,
			ggz_group_name: "", // 下拉选择框的搜索字段
			ggz_fetching: false, // 用于控制提示
			ggz_loading_more_control: true, // 上拉加载更多控制
			ggz_loading_more_hint: false, // 上拉加载更多的提示
			r_campaign_id: [], // 用于搜索请求
			// 广告组结束
			
			// 广告计划
			plan_Select: [], // 选择广告计划
			plan_Blur: [], // 保存一份，用于失去焦点后，回复原来的数值
			plan_page: 1,
			p_plan_name: "", // 下拉选择框的搜索字段
			plan_fetching: false, // 用于控制提示
			plan_loading_more_control: true, // 上拉加载更多控制
			plan_loading_more_hint: false, // 上拉加载更多的提示
			r_plan_id: [], // 广告计划
			// 广告计划结束
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"广告计划名称",width:110, sort_status:0, type:"plan_name", text_right: false,sort_:90,sort_control: false, show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"操作",width:160, sort_status:0, type:"cz", text_right: false,sort_:88,sort_control: false, show_control: true,},
				
				{title:"广告状态",width:80, sort_status:0, type:"status", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"出价(元)",width:70, sort_status:0, type:"cpa_bid", text_right: true,sort_:89,sort_control: false, show_control: true,},
				
				{title:"消耗",width:85, sort_status:0, type:"cost", text_right: true,sort_:87,sort_control: true, show_control: true,},
				{title:"展示数",width:85, sort_status:0, type:"show", text_right: true,sort_:86,sort_control: true, show_control: false,},
				{title:"ecpm",width:80, sort_status:0, type:"avg_show_cost", text_right: true,sort_:85,sort_control: true, show_control: false,},
				{title:"点击数",width:80, sort_status:0, type:"click", text_right: true,sort_:39,sort_control: true, show_control: false,},
				{title:"平均点击单价",width:80, sort_status:0, type:"avg_click_cost", text_right: true,sort_:38,sort_control: true, show_control: false,},
				{title:"点击率",width:80, sort_status:0, type:"ctr", text_right: true,sort_:37,sort_control: true, show_control: false,},
				{title:"激活数",width:80, sort_status:0, type:"active", text_right: true,sort_:39,sort_control: true, show_control: true,},
				{title:"激活成本",width:85, sort_status:0, type:"active_cost", text_right: true,sort_:39,sort_control: true, show_control: true,},
				{title:"转化数",width:80, sort_status:0, type:"convert", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"平均转化成本",width:80, sort_status:0, type:"convert_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"转化率",width:80, sort_status:0, type:"convert_rate", text_right: true,sort_:35,sort_control: true, show_control: false,},
				
				{title:"当天总充值金额",width:85, sort_status:0, type:"eff_total_pay_money", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天分成金额",width:85, sort_status:0, type:"eff_total_left_money", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充分成金额",width:85, sort_status:0, type:"eff_total_left_money_fisrt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天总ROI",width:70, sort_status:0, type:"eff_roi", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充ROI",width:80, sort_status:0, type:"eff_roi_first", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"落地页跳转数",width:80, sort_status:0, type:"user_click", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"跳转成本",width:80, sort_status:0, type:"lp_price", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天订单笔数",width:80, sort_status:0, type:"eff_total_order_cnt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天充值用户数",width:90, sort_status:0, type:"eff_total_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天充值用户成本",width:90, sort_status:0, type:"eff_total_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"ARPU",width:80, sort_status:0, type:"arpu", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户数",width:80, sort_status:0, type:"eff_report_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户成本",width:80, sort_status:0, type:"eff_report_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"计划回传比例",width:250, sort_status:0, type:"report_config", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"落地页回传比例",width:80, sort_status:0, type:"link.report_per", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"落地页ID",width:100, sort_status:0, type:"link_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"广告计划ID",width:140, sort_status:0, type:"plan_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"广告组名称",width:140, sort_status:0, type:"group_name", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"账户名称",width:130, sort_status:0, type:"adv_name", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"投手",width:120, sort_status:0, type:"admin_list", text_right: false,sort_:35,sort_control: false, show_control: true,},
			],
			tableShowData: [], // 显示表格内容
			tableSumData: {}, // 总计

			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_sort_field: "", // 排序参数
			r_sort_type: "", // 排序类型
			r_admin_id: [], // 选择投手
			r_adv_id: [], // 选择的广告账户
			r_adv_id_input: "", // 广告账户ID精准搜索
			r_status: "", // 广告状态
			r_opt_status: "", // 操作状态
			r_export: "", // 是否导出，为1表示导出
			r_book_type: "", // 书城频道
			r_book_fun: "", // 书城形式
			r_channel_id: "", // 书城渠道
			r_campaign_id_input: "", // 广告组ID精准搜索
			r_plan_id_input: "", // 广告计划ID精准搜索
			
			filterData: {
				op_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				book_type: {
					list: [{}],
				}
			}, 
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量设置负责人
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			pl_value: undefined, // 选择框的默认值
			
			// 批量删除弹窗
			dl_modal: false,
			dl_loading: false,
			
			sync_true: false, // 刷新的icon是否旋转
			sync_true_control: true, // 刷新的节流控制
			same_day_s: "", // 昨天日期
			same_day_e: "", // 当天日期
			sameDay:[{},{}], // 当天日期的数据
			
			personChargeList: {}, // 投手
			conditionSelect: {
				opt_status: {},
				status: {},
			} , // 搜索条件（广告状态、操作状态）
			
			
			// 回传比例侧边栏
			hc_plan_id: "", // 回传id
			hc_drawer_title: "", // 标题
			hc_visible: false, // 侧边栏是否显示
			hc_button_loading: false, // 回传侧边栏确认按钮的加载状态
			hc_form_hint: "",
			
			h_plan_name: "", // 广告计划名称，仅用于展示，不用于请求
			h_plan_id: "", // 广告计划ID
			h_report_money_limit: window.$InitialValues.report_money_limit, // 回传最低金额
			h_user_reg_time_condition: 1, // 注册时间
			h_order_time_condition_type: 1, // 充值时间
			h_order_time_condition_n: 24, // 注册后几小时内首次充值
			h_report_per: 100, // 回传比例
			h_status: true, // 是否启用-回传侧边栏
			// 自定义回传
			h_report_per_type: 1, // 回传比率类型，1=老回传比率，2=自定义回传比率
			hCustomData: [
				{
					id: 'c' + new Date().getTime(),
					h_min_money: 0, // 金额区间最小金额
					h_max_money: 0, // 金额区间最大金额
					h_order_per: [{ // 下单回传比率数组
						id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
						value: 0
					}],
					h_purcharse_day_per: [{ // 付费2：后补序列
						id: 'f1',
						value: 0
					}],
				}
			],
			h_cost_type: 0, // 自定义回传比率才有，是否设置最低广告消耗金额回传0=否，1=是
			h_cost: 0, // 自定义回传比率才有，消耗金额
			h_is_supply_active_pay: 0, // 是否开启二次回传，0=否，1=是
			
			h_type_pl: 0, // 0表示个设置，1表示批量设置
			
			type_button_text: "全部", // 只看有消耗/只看有展示的按钮文案
			type_button_key: '1', // 当前选中状态的key，避免点击同样的选项重复请求。默认是全部
			have_cost: "", // 只看有消耗
			have_show: "", // 只看有展示
			
			role_control: [], // 用户权限控制
			
			
			// 自定义列
			custtom_visible: false, // 自定义列弹窗
			customCheckboxData: [ // 自定义列
				{
					label: "基础信息：",
					showTitle:['status','cpa_bid'],
					custom_checkbox: true,
					type:"jc"
				},
				{
					label: "平台数据项：",
					showTitle:['cost','show','avg_show_cost','click','avg_click_cost','ctr','active','active_cost','convert','convert_cost','convert_rate'],
					custom_checkbox: false,
					type:"ty"
				},
				{
					label: "飞碟统计数据项：",
					showTitle:["eff_total_pay_money","eff_total_left_money","eff_total_left_money_fisrt","eff_roi","eff_roi_first","user_click","lp_price","eff_total_order_cnt","eff_total_pay_user_cnt","eff_total_pay_user_cost","arpu","eff_report_pay_user_cnt","eff_report_pay_user_cost",],
					custom_checkbox: false,
					type:"sjx"
				},
				{
					label: "其他信息：",
					showTitle:['report_config','link.report_per','link_id','plan_id','group_name','adv_name','admin_list'],
					custom_checkbox: true,
					type:"qt"
				},
			],
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		function jsTable(){
			let nn = 0
			that.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			that.table_scroll_width = nn + 30 + 30
			if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
			else { that.table_null_width = that.table_scroll_width - 60 }
			
			that.$nextTick(()=>{
				// 给母页面的tab传递粘性定位用的参数
				that.$bus.$emit("stickyData", that.table_scroll_width);
			})
		}
		
		// 有自定义列缓存
		if(localStorage.getItem("table_custtom_JLjh")){
			
			try{
				let s_title = JSON.parse(localStorage.getItem("table_custtom_JLjh"))
				that.rableTitle.forEach(res=>{
					s_title.forEach(re_z=>{
						if(res.type == re_z.type){
							res.show_control = re_z.show_control
						}
					})
				})
				// 重新计算表格宽度
				that.computeTableWidth()
				
			}catch(e){
				jsTable()
			}
		}
		else { // 没自定义列缓存
			// console.log("没自定义列缓存");
			jsTable()
		}
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 获取账户下拉
		that.$refs.getAdvSelect.getSelectData()
		
		// 接收从计划页面传过来的参数
		if(this.$route.params){
			if(this.$route.params.jump_id){
				this.r_campaign_id = this.$route.params.jump_id
				
			}
			
			if(this.$route.params.router_adv_id){ // 广告账户
				console.log("this.$route.params",this.$route.params);
				this.r_adv_id = this.$route.params.router_adv_id
				
			}
		}
		if(this.$route.query){
			// 鼠标右键新窗口打开过来的
			if(this.$route.query.router_adv_id){ // 广告账户
				this.r_adv_id = this.$route.query.router_adv_id
				that.$nextTick(()=>{
					that.$refs.getAdvSelect.setValue(Number(this.r_adv_id))
				})
			}
		}
		
		// 获取昨天前日期
		let date1 = new Date(new Date().getTime() - 86400000);
		let same_day1
		if(date1.getDate() < 10){
			same_day1 = "0" + date1.getDate()
		}
		else {
			same_day1 = date1.getDate()
		}
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		// console.log("date2.getDate();",date2.getDate())
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay() // 默认只获取当天
		
		// 这里要注意date2.getFullYear()和month2(month2大于10就会为数字，小于10会加上字符串0就变成字符串了)都为数字，所以要转一下字符串，否则的话就是数字相加了
		that.same_day_s = date2.getFullYear() + month2.toString() + same_day1; // 获取昨天日期
		that.same_day_e = date2.getFullYear() + month2.toString() + day2; // 获取当天日期
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		// 获取当天统计数据
		that.RefreshButton()
		
		// 搜索条件（广告状态、操作状态）
		JLjhSelectStatus().then(res=>{
			console.log("搜索条件（广告状态、操作状态）",res);
			that.conditionSelect = res.data.data
		})
		
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
		
		// 广告计划
		JLjhSelectPlan({
			page: 1,
			limit: that.s_limit,
		}).then(res=>{
			console.log("广告计划",res);
			that.plan_Select = res.data.data.data
			that.plan_Blur = res.data.data.data
		})
		
		// 广告组选择
		JLggzSelectGroup({
			page: 1,
			limit: that.s_limit,
		}).then(res=>{
			console.log("获取广告组选择",res);
			that.ggz_Select = res.data.data.data
			that.ggz_Blur = res.data.data.data
		})
		
			
		// 搜索
		that.searchButton()
			
			
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		
		handleChangeA(e){ // 选择投手
			console.log(e);
			// 未设置的选项与其他选项不可以同时选，所以这里要加限制
			if(e.length > 1 && e.indexOf('-1') > -1){
				this.$message.warning('未设置与其他选项不能同时选择');
			}
			else {
				this.r_admin_id = e
			}
		},
		handleChangeB(e){ // 选择广告账户
			// console.log(e);
			this.r_adv_id = e
		},
		handleChangeF(e){ // 请选择广告状态
			console.log(e);
			this.r_status = e
		},
		handleChangeG(e){ // 操作状态
			console.log(e);
			this.r_opt_status = e
		},
		handleChangeX(e){ // 书城频道
			this.r_book_type = e
		},
		handleChangeY(e){ // 书城形式
			this.r_book_fun = e
		},
		handleChangeZ(e){ // 书城渠道
			this.r_channel_id = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
				
				// 这个页面经常需要通过消费的排序或其他排序来看数据，所以这里清空的话，每次搜索就要重新点排序，麻烦，干脆注释
				// 排序的状态重置
				// that.r_sort_field = ''
				// that.r_sort_type = ''
				// that.rableTitle.forEach(res=>{
				// 	res.sort_status = 0 // 排序的状态重置
				// })
			}
			
			// 为了把选择账户下拉框与账户ID搜索框的数据进行整合，因为这两个请求字段是一样的
			let aaa_id = null
			if(that.r_adv_id_input && that.r_adv_id.length == 0){
				aaa_id = that.r_adv_id_input
			}
			else if(!that.r_adv_id_input && that.r_adv_id.length > 0){
				aaa_id = that.r_adv_id
			}
			else if(that.r_adv_id_input && that.r_adv_id.length > 0){
				// 不用去重，试了下，就算传重复的，后端那边会过滤
				let iii = JSON.stringify(that.r_adv_id) // 深拷贝，不然搜索框里的值会出现下拉框，因为下拉框有:value="r_adv_id"
				let jjj = JSON.parse(iii)
				jjj.push(that.r_adv_id_input)
				aaa_id = jjj
			}
			else {
				aaa_id = that.r_adv_id
			}
			// 把广告组的下拉框和ID搜索整合
			let ggg_id = null
			if(that.r_campaign_id_input && that.r_campaign_id.length == 0){
				ggg_id = that.r_campaign_id_input
			}
			else if(!that.r_campaign_id_input && that.r_campaign_id.length > 0){
				ggg_id = that.r_campaign_id
			}
			else if(that.r_campaign_id_input && that.r_campaign_id.length > 0){
				// 不用去重，试了下，就算传重复的，后端那边会过滤
				let iii = JSON.stringify(that.r_campaign_id) // 深拷贝，不然搜索框里的值会出现下拉框，因为下拉框有:value="r_adv_id"
				let jjj = JSON.parse(iii)
				jjj.push(that.r_campaign_id_input)
				ggg_id = jjj
			}
			// 把广告计划的下拉框和ID搜索整合
			let ppp_id = null
			if(that.r_plan_id_input && that.r_plan_id.length == 0){
				ppp_id = that.r_plan_id_input
			}
			else if(!that.r_plan_id_input && that.r_plan_id.length > 0){
				ppp_id = that.r_plan_id
			}
			else if(that.r_plan_id_input && that.r_plan_id.length > 0){
				// 不用去重，试了下，就算传重复的，后端那边会过滤
				let iii = JSON.stringify(that.r_plan_id) // 深拷贝，不然搜索框里的值会出现下拉框，因为下拉框有:value="r_adv_id"
				let jjj = JSON.parse(iii)
				jjj.push(that.r_plan_id_input)
				ppp_id = jjj
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_time: that.startTime.replace(/-/g, ''),
				end_time: that.endTime.replace(/-/g, ''),
				advertiser_id: aaa_id, // 账户id
				campaign_id: ggg_id, // 广告组
				plan_id: ppp_id, // 广告计划
			}
			if(that.r_book_type){ r_data.book_type = that.r_book_type } // 书城频道
			if(that.r_book_fun){ r_data.book_fun = that.r_book_fun } // 书城形式
			if(that.r_channel_id){ r_data.channel_id = that.r_channel_id } // 书城渠道
			
			// 超级管理、投放管理可以有 投手
			if(Object.keys(that.personChargeList).length > 0){
				r_data.admin_id = that.r_admin_id // 选择投手
			}
			if(that.r_opt_status){ // 操作状态
				r_data.opt_status = that.r_opt_status
			}
			if(that.r_status){
				r_data.status = that.r_status // 广告状态
			}
			// 如有排序字段就加上
			if(that.r_sort_field){ 
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			// 只看有消耗/只看有展示 按钮
			if(that.have_cost == "1"){ // 消耗
				r_data.have_cost = "1"
			}
			else if(that.have_show == "1"){ // 展示
				r_data.have_show = "1"
			}
			// 是否导出
			if(that.r_export == "1"){
				r_data.export = "1"
			}
			// 正常搜索
			if(that.r_export != "1"){
				console.log("r_data",r_data);
				JLjhList(r_data).then(res=>{
					console.log('搜索',res);
					
					// 因为批量操作的开启和暂停没有弹窗提示选了哪些内容，所以就不支持翻页也存着上一个页面存的内容
					// 每次请求重置批量选择的状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					that.r_export = ""
					
					that.search_button_loading = false
					
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ 
						if(type == "export"){ // 表示导出
							that.$message.success(res.data.msg || "导出成功");
						}
						else {
							let data = res.data.data.data
							data.forEach(res=>{
								res.checked = false // 用于多选和单选
								res.popover_clicked = false // 表格-操作栏的气泡卡片
								if(res.opt_status == '启用'){
									res.status_checked = true
								}
								else { // 暂停
									res.status_checked = false
								}
							})
							
							
							that.$message.success('搜索成功');
							
							that.tableSumData = res.data.data.plan_sum
							that.table_total = res.data.data.total
							that.tableShowData = data
						}
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
				})
				.catch(err=>{
					console.log("err",err);
					// 重置状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					
					that.search_button_loading = false
					that.r_export = ""
					
					that.$message.error('搜索失败，请检查网络状态')
					
					// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					setTimeout(()=>{
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					},300)
				})
			}
			else if(that.r_export == "1"){
				JLjhExport(r_data).then(res=>{
					console.log('导出',res);
					
					that.r_export = ""
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
					else {
						
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
				})
			}
			
		},
		// 导出
		exportButton(){
			this.r_export = "1"
			this.searchButton('export')
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 广告组部分
		handleChangeC(e){ // 选择广告组
			console.log(e);
			this.r_campaign_id = e
		},
		popupScrollGGZ(e){ // 上拉触底加载更多
			// console.log(e.target.scrollHeight);
			// console.log(e.target.scrollTop);
			// console.log(e.target.scrollHeight - e.target.scrollTop);
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.ggz_loading_more_control){ // 节流，保证这期间只执行一次
					this.ggz_loading_more_hint = true
					this.ggz_loading_more_control = false
					let that = this
					that.ggz_page = that.ggz_page + 1
					console.log("上拉触底加载更多");
					JLggzSelectGroup({
						page: that.ggz_page,
						limit: that.s_limit,
						group_name: that.ggz_group_name,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.ggz_Select 
						that.ggz_loading_more_hint = false
						that.ggz_Select = data.concat(res.data.data.data) 
						that.ggz_fetching = false
						that.ggz_loading_more_control = true
					})
				}
			}
		},
		// 选择框搜索-选择广告组
		selectGgzSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.ggz_Select = []
			that.ggz_fetching = true
			that.ggz_group_name = e
			
			JLggzSelectGroup({
				page: 1,
				limit: that.s_limit,
				group_name: e,
			}).then(res=>{
				console.log('选择',res);
				that.ggz_page = 1
				that.ggz_Select = res.data.data.data
				that.ggz_fetching = false
			})
		},
		// 失去焦点
		ggzBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.ggz_page = 1
			that.ggz_group_name = '' // 清空
			that.ggz_Select = that.ggz_Blur 
		},
		// 广告组部分结束
		
		// 广告计划部分开始
		handleChangeE(e){
			console.log(e);
			this.r_plan_id = e
		},
		popupScroll_Plan(e){ // 上拉触底加载更多
			// console.log(e.target.scrollHeight);
			// console.log(e.target.scrollTop);
			// console.log(e.target.scrollHeight - e.target.scrollTop);
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.plan_loading_more_control){ // 节流，保证这期间只执行一次
					this.plan_loading_more_hint = true
					this.plan_loading_more_control = false
					let that = this
					that.plan_page = that.plan_page + 1
					console.log("上拉触底加载更多");
					JLjhSelectPlan({
						page: that.plan_page,
						limit: that.s_limit,
						plan_name: that.p_plan_name,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.plan_Select 
						that.plan_loading_more_hint = false
						that.plan_Select = data.concat(res.data.data.data) 
						that.plan_fetching = false
						that.plan_loading_more_control = true
					})
				}
			}
		},
		// 选择框搜索-选择广告计划
		select_Plan_Search(e){
			console.log("选择框搜索",e);
			let that = this
			that.plan_Select = []
			that.plan_fetching = true
			that.p_plan_name = e
			
			JLjhSelectPlan({
				page: 1,
				limit: that.s_limit,
				plan_name: e,
			}).then(res=>{
				console.log('选择',res);
				that.plan_page = 1
				that.plan_Select = res.data.data.data
				that.plan_fetching = false
			})
		},
		// 失去焦点
		planBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.plan_page = 1
			that.p_plan_name = '' // 清空
			that.plan_Select = that.plan_Blur 
		},
		// 广告计划部分结束
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		plRequest(e){
			let that = this
			
			// 把相同adv_id的进行归类，分批次请求
			let arr = []
			this.selectedData.forEach(res=>{
				if(arr.length > 0){
					let ttt = true
					arr.forEach(res_z=>{
						if(res.adv_id == res_z){
							ttt = false
						}
					})
					if(ttt){
						arr.push(res.adv_id)
					}
				}
				else {
					arr.push(res.adv_id)
				}
			})
			console.log('this.selectedData',this.selectedData);
			let r_arrys = []
			arr.forEach(res=>{
				let obj = {
					o_adv_id: res,
					o_group_ids: []
				}
				this.selectedData.forEach(res_z=>{
					if(res_z.adv_id == res){
						obj.o_group_ids.push(res_z.id)
					}
				})	
				r_arrys.push(obj)
			})
			
			console.log('r_arrys',r_arrys);
			
			
				let r_opt_status
				
				if(e.key == '1'){ // 开启
					r_opt_status = "AD_STATUS_ENABLE"
				}
				else if(e.key == '2'){ // 暂停
					r_opt_status = "AD_STATUS_DISABLE"
				}
				else if(e.key == '3'){ // 删除
					r_opt_status = "AD_STATUS_DELETE"
				}
				
				let promise_arr = []
				for(let i = 0; i < r_arrys.length ; i ++){
					let ppp = new Promise((resolve,reject)=>{
						JLjhEditStatus({
							adv_id: r_arrys[i].o_adv_id,
							plan_ids: r_arrys[i].o_group_ids,
							opt_status: r_opt_status,
						}).then(res=>{
							console.log('开启/暂停/删除',res);
							if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){  // 8011表示内容为空
								resolve('OK')
							}
							else if(res.data.code === 401){ // 未登录
								reject('err')
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								reject('err')
								that.$message.error(`其他错误：${res.data.msg}`);
							}
						}).catch(err=>{
							reject('err')
						})
					})
					promise_arr.push(ppp)
				}
				// console.log("promise_arr",promise_arr)
				// 等待请求全部完成
				const result = Promise.all(promise_arr).then(res=>{
					// console.log('resultresult',res);
					that.search_button_loading = false
					
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					if(e.key == '1'){ // 开启
						that.$message.success('开启成功');
					}
					else if(e.key == '2'){ // 暂停
						that.$message.success('暂停成功');
					}
					else if(e.key == '3'){ // 删除
						that.dl_loading = false
						that.dl_modal = false
						that.$message.success('删除成功');
					}
					
					that.searchButton()
					
				}).catch(err=>{
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					that.checkAll = false
					that.indeterminate = false
					
					that.dl_loading = false
					
					that.search_button_loading = false
					that.$message.error('请求失败，请刷新页面再试')
				})
				console.log("result",result); 
			
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
		    console.log('click', e);
			if(this.selectedData.length > 0){
				let that = this
				if(e.key == '1' || e.key == '2'){ // 开启
					that.search_button_loading = true
					
					// console.log(this.selectedData);
					that.plRequest(e)
				}
				
				else if(e.key == '3'){ // 删除
					this.dl_modal = true
				}
				else if(e.key == '5'){ // 修改回传参数
					this.h_type_pl = 1
					this.hc_visible = true
				}
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		// 全部/只看消耗/只看显示
		handleMenuClickB(e){
			
			if(e.key != this.type_button_key){ // 避免重复点击
				console.log(e);
				if(e.key == '1'){ // 全部
					this.have_cost = "", // 消耗
					this.have_show = "", // 展示
					this.type_button_key = e.key
					this.type_button_text = "全部"
					this.searchButton()
				}
				else if(e.key == '2'){ // 消耗
					this.have_cost = "1", // 消耗
					this.have_show = "", // 展示
					this.type_button_key = e.key
					this.type_button_text = "只看有消耗"
					this.searchButton()
				}
				else if(e.key == '3'){ // 展示
					this.have_cost = "", // 消耗
					this.have_show = "1", // 展示
					this.type_button_key = e.key
					this.type_button_text = "只看有展示"
					this.searchButton()
				}
			}
		},
		// 开启、暂停按钮点击
		statusCheckbox(e,item){
			console.log('qqq',e,item);
			// item.status_checked = e
			this.selectedData.push(item)
			if(item.opt_status == '启用'){ 
				console.log('启用');
				this.plRequest({key: "2"}) // 当前为开启状态就要改为暂停状态
			}
			else { // 暂停
				console.log('暂停');
				this.plRequest({key: "1"}) // 当前为暂停状态就要改为开启状态
			}
			
		},
		
		
		
		// 点击负责人
		clickFzr(e){
			console.log(e)
			let that = this
			this.selectedData = []
			this.selectedData.push(e)

			e.auth.forEach(res=>{
				let obj = {
					label: res.admin_name,
					key: res.admin_id
				}
				this.pl_select_admin.push(obj)
			})
			this.pl_modal = true
		},
		
		// 批量设置负责人，选择负责人
		handleChangeD(e){
			console.log(e);
			this.pl_value = e
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		// 批量设置负责人弹窗确认按钮
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择负责人
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.id)
				})
				console.log("i_data",i_data);
				
				putSetAdvUser({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置负责人",res);
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					that.plCancel()
					that.$message.success('设置成功');
					that.searchButton()
				})
			}
			else {
				this.$message.warning('请先选择负责人');
			}
			
			
		},
		// 删除选择的负责人
		delSelectAdmin(index){
			this.pl_select_admin.splice(index,1)
		},
		// 批量设置负责人弹窗取消按钮
		plCancel(){
			if(this.pl_loading){
				return 
			}
			this.pl_select_admin = []
			this.pl_modal = false
			this.pl_value = undefined
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			// console.log(that.r_sort_field);
			// console.log(that.r_sort_type);
			that.r_page = 1
			that.searchButton()
		},
		
		
		// 批量删除确认
		dlOk(){
			let that = this
			
			that.dl_loading = true
			that.plRequest({key:"3"})
		},
		// 删除弹窗取消
		dlCancel(){
			if(this.dl_loading){
				return
			}
			
			this.dl_modal = false
		},
		
		
		// 刷新当天统计数据
		RefreshButton(type){
			let that = this
			this.sync_true = true
			if(this.sync_true_control){ // 节流控制
				that.sync_true_control = false
				// console.log("that.same_day",that.same_day);
				JLjhPlanDate({
					start_time: that.same_day_s,
					end_time: that.same_day_e,
					type: 2
				}).then(res=>{
					that.sync_true = false
					that.sync_true_control = true
					console.log("刷新当天统计数据",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						let data = res.data.data.data
						if(data.length > 0){
							let s_data = []
							let un_data = []
							if(data.length == 2){ // 有两天数据
								data.forEach(res=>{
									// 保证当天的数据放在第一项
									if(res.date_key == that.same_day_e){ 
										s_data.push(res)
									}
									else {
										un_data.push(res)
									}
								})
								that.sameDay = s_data.concat(un_data)
							}
							else { // 只返回昨天数据时
								that.sameDay[0] = {
									cn_plan_num: null,
									cost: null,
									convert: null,
									avg_cost: null,
									charge_money: null,
									dayToFixed: null,
								}
								that.sameDay[1] = data[0]
							}
						}
						else { // 内容为空
							that.sameDay = [
								{},
								{}
							]
						}
						
						if(type == 'button'){
							that.$message.success('刷新成功');
						}
					}
					else {
						that.search_button_loading = false
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`当天统计数据错误：${res.data.msg}`);
						}
					}
					// console.log("that.sameDay",that.sameDay);
					
					
				})
				.catch(err=>{
					that.sync_true = false
					that.sync_true_control = true
					that.$message.error(`刷新失败`);
				})
			}
			
		},
		
		// 计划回传比例侧边栏开始
		setPlanHcbl(e){
			console.log("jh",e);
			this.h_plan_name = e.plan_name
			this.h_plan_id = e.plan_id
			let ee = e.report_config
			if(e.report_config){
				this.h_report_money_limit = ee.report_money_limit, // 回传最低金额
				this.h_user_reg_time_condition = ee.user_reg_time_condition, // 注册时间
				this.h_order_time_condition_type = ee.order_time_condition_type, // 充值时间
				this.h_order_time_condition_n = ee.order_time_condition_n, // 注册后几小时内首次充值
				this.h_report_per = ee.report_per // 回传比例
				
				// 自定义回传部分
				this.h_report_per_type = ee.report_per_type // 回传类型
				this.h_is_supply_active_pay = ee.is_supply_active_pay // 是否开启二次回传，0=否，1=是
				if(ee.report_per_type == 2){ // 自定义回传
					this.h_cost_type = ee.cost_type
					this.h_cost = ee.cost
					if(ee.report_per_self){
						let h_data = []
						let e_data = ee.report_per_self
						e_data.forEach((res,index)=>{
							let obj = {
								id: 'c' + index.toString() + new Date().getTime(),
								h_min_money: res.min_money, // 金额区间最小金额
								h_max_money: res.max_money, // 金额区间最大金额
							}
							
							let aaa = []
							res.order_per.forEach((res_a,index_a)=>{
								let ooo = {
									id: 'a' + index_a.toString() + new Date().getTime(), // 因为会有删除操作，所以要有id，避免删除之后会乱
									value: res_a
								}
								aaa.push(ooo)
							})
							
							let fff = []
							res.purcharse_day_per.forEach((res_a,index_a)=>{
								let ooo = {
									id: 'f' + index_a.toString() + new Date().getTime(), // 因为会有删除操作，所以要有id，避免删除之后会乱
									value: res_a
								}
								fff.push(ooo)
							})
							
							obj.h_order_per = aaa
							obj.h_purcharse_day_per = fff
							
							h_data.push(obj)
						})
						this.hCustomData = h_data
					}
				}
				
				if(ee.status == 1){ // 启用
					this.h_status = true // 是否启用-回传侧边栏
				}
				else {
					this.h_status = false
				}
				
			}
			this.h_type_pl = 0
			this.hc_visible = true
		},
		// 回传比例确认按钮
		hcRequest(){
			let that = this
			
			let r_data = {
				report_per_type: that.h_report_per_type, // 1=老回传比率，2=自定义回传比率
				is_supply_active_pay: that.h_is_supply_active_pay // 是否开启二次回传，0=否，1=是
			}
			
			
			const hc_p = new Promise((resolve,reject)=>{
				if(that.h_report_per_type == 2){ // 自定义回传
					let rrr = []
					let check_control = true
					for(let i = 0;i < that.hCustomData.length; i++){
						let res = JSON.parse(JSON.stringify(that.hCustomData[i]))
						let index = Number(JSON.parse(JSON.stringify(i)))
						// 规则校验。有几种情况。1后面的订单金额必须要大于前面的订单金额。
						// 2.订单金额范围之间不能冲突，覆盖的范围不能相同
						if(res.h_max_money < res.h_min_money){
							that.$message.warning('金额范围配置错误。第二个数值要大于等于第一个数值');
							check_control = false
							break;
						}
						// 第二点 校验。订单金额范围之间不能有冲突
						for(let z = 0;z < that.hCustomData.length; z++){
							let z_es = JSON.parse(JSON.stringify(that.hCustomData[z]))
							// 把每一个订单范围的金额的第一个值，跟全部的范围进行对比，如果在范围内则不能请求
							if( i != z && res.h_min_money >= z_es.h_min_money && res.h_min_money <= z_es.h_max_money){
								that.$message.warning('订单金额范围之间不能冲突，覆盖的范围不能相同');
								check_control = false
								return
							}
							else if( i != z && res.h_max_money >= z_es.h_min_money && res.h_max_money <= z_es.h_max_money){
								that.$message.warning('订单金额范围之间不能冲突，覆盖的范围不能相同');
								check_control = false
								return
							}
						}
						
						
						let obj = {
							min_money: res.h_min_money,
							max_money: res.h_max_money,
						}
						let aaa = []
						res.h_order_per.forEach(res_a=>{
							aaa.push(res_a.value)
						})
						
						let ccc = []
						res.h_purcharse_day_per.forEach(res_a=>{
							ccc.push(res_a.value)
						})
						obj.order_per = aaa
						
						obj.purcharse_day_per = ccc
						rrr.push(obj)
					}
					
					console.log("check_control",check_control)
					if(check_control){ // true表示校验成功
						console.log("check_control",'校验成功')
						resolve('校验成功')
					}
					else {
						console.log("check_control",'校验失败')
						reject('校验失败')
					}
					r_data.report_per_self = rrr
					r_data.cost_type = that.h_cost_type
					r_data.cost = that.h_cost
				}
				else { // 固定列回传
					resolve('校验成功')
				}
			})
			
			// 先校验完，在进行接下来的操作
			hc_p.then(value=>{ // promise状态-成功。表示校验成功，继续进行下一步
				
				that.hc_button_loading = true
				
				// 老版回传。都带上
				r_data.report_money_limit = that.h_report_money_limit, // 回传最低金额
				r_data.user_reg_time_condition = that.h_user_reg_time_condition, // 注册时间
				r_data.order_time_condition_type = that.h_order_time_condition_type, // 充值时间
				r_data.report_per = that.h_report_per // 回传比例
				
				// 选了注册后充值
				if(that.h_order_time_condition_type == 0){ 
					r_data.order_time_condition_n = that.h_order_time_condition_n // 注册后几小时内首次充值
				}
				
				
				if(that.h_status){// 是否启用
					r_data.status = 1 // 启用
				}
				else {
					r_data.status = 0
				}
			
				// 是否批量
				if(that.h_type_pl == 1){ // 批量
					let pl_plan_ids = []
					that.selectedData.forEach(res=>{
						pl_plan_ids.push(res.plan_id)
					})
					console.log("pl_plan_ids",pl_plan_ids);
					// 设置请求参数
					r_data.plan_ids = pl_plan_ids
					
					JLjhPlReportConfig(r_data).then(res=>{
						that.hc_button_loading = false
						console.log('批量设置回传',res)
						if(res.data.code == 0){
							
							that.selectedData = []
							that.tableShowData.forEach(res=>{
								res.checked = false // 重置
							})
							
							that.hcCloseDrawer()
							that.$message.success('设置成功');
							that.searchButton()
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					})
				}
				else { // 单个设置
					r_data.plan_id = that.h_plan_id, // 广告计划ID
					console.log("发送请求",r_data);
					JLjhReportConfig(r_data).then(res=>{
						that.hc_button_loading = false
						console.log('确认设置回传',res)
						if(res.data.code == 0){
							
							that.selectedData = []
							that.tableShowData.forEach(res=>{
								res.checked = false // 重置
							})
							
							that.hcCloseDrawer()
							that.$message.success('设置成功');
							that.searchButton()
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
						
					})
					.catch(err=>{
						that.hc_button_loading = false
						that.hcCloseDrawer()
						that.$message.error('设置失败，请检查网络状态')
					})
				}
			
			},(reason)=>{ // promise状态-失败
				
			})
		},
		// 回传比例侧边栏关闭
		hcCloseDrawer(){
			if(this.hc_button_loading){
				return
			}
			console.log('111111');
			this.hc_visible = false
			this.hc_form_hint = ""
			// 充值状态
			this.h_report_money_limit = window.$InitialValues.report_money_limit, // 回传最低金额
			this.h_user_reg_time_condition = 1, // 注册时间
			this.h_order_time_condition_type = 1, // 充值时间
			this.h_order_time_condition_n = 24, // 注册后几小时内首次充值
			this.h_report_per =  100// 回传比例
			this.h_status = true
			this.h_plan_name = ""
			this.h_plan_id = ""
			this.h_type_pl = 0
			
			// 自定义回传。之所以这里要重置是因为还有个批量按钮的入口
			this.h_report_per_type = 1, // 回传比率类型，1=老回传比率，2=自定义回传比率
			this.hCustomData = [
				{
					id: 'c' + new Date().getTime(),
					h_min_money: 0, // 金额区间最小金额
					h_max_money: 0, // 金额区间最大金额
					h_order_per: [{ // 下单回传比率数组
						id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
						value: 0
					}],
					h_purcharse_day_per: [{ // 付费次日-30日回传比率数组
						id: 'f1',
						value: 0
					}],
				}
			],
			this.h_cost_type = 0
			this.h_cost = 0
			this.h_is_supply_active_pay = 0
			
			document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			setTimeout(()=>{
				document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			},300)
		},
		// 回传比例侧边栏的是否启用按钮
		hcDrawerSwitch(e){
			console.log(e);
			this.h_status = e
		},
		hcRadioA(e){ // 注册时间
			console.log(e.target.value);
			this.h_user_reg_time_condition = e.target.value
		},
		hcRadioB(e){ // 充值时间
			console.log(e.target.value);
			this.h_order_time_condition_type = e.target.value
		},
		// 回传比例的数字输入框
		hcNumber(e,type){
			console.log(e,type);
			if(type == 1){ // 回传最低金额(元)
				this.h_report_money_limit = e
			}
			else if(type == 2){ // 注册后几小时内首次充值
				this.h_order_time_condition_n = e
			}
			else if(type == 3){ // 回传比例
				this.h_report_per = e
			}
		},
		// 自定义回传序列开始
		hcRadioE(e){ // 设置方式 回传比率类型，1=老回传比率，2=自定义回传比率
			this.h_report_per_type = e.target.value
		},
		hcRadioP(e){ // 自定义回传比率才有，是否设置最低广告消耗金额回传0=否，1=是
			// console.log(e);
			this.h_cost_type = e.target.value
		},
		hcRadioS(e){ // 是否开启付费2
			this.h_is_supply_active_pay = e.target.value
		},
		hcCustomHandleA(indd){ // 下单回传序列
			let obj = {
				value: 0,
				id: 'a' + new Date().getTime()
			}
			this.hCustomData[indd].h_order_per.push(obj)
		},
		hcCustomHandleB(indd){ // 注册次日-30日订单，付费回传序列
			let obj = {
				value: 0,
				id: 'f' + new Date().getTime()
			}
			this.hCustomData[indd].h_purcharse_day_per.push(obj)
		},
		hcCustomHandleC(indd){ // 删除
			if(this.hCustomData[indd].h_order_per.length > 1){
				this.hCustomData[indd].h_order_per.splice(this.hCustomData[indd].h_order_per.length -1 , 1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		hcCustomHandleD(indd){ // 删除
			if(this.hCustomData[indd].h_purcharse_day_per.length > 1){
				this.hCustomData[indd].h_purcharse_day_per.splice(this.hCustomData[indd].h_purcharse_day_per.length -1 , 1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		hcCustomDelA(index,indd){ // 下单回传序列-删除操作
			if(this.hCustomData[indd].h_order_per.length > 1){
				this.hCustomData[indd].h_order_per.splice(index,1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		hcCustomDelB(index,indd){ // 注册次日-30日订单-删除操作
			if(this.hCustomData[indd].h_purcharse_day_per.length > 1){
				this.hCustomData[indd].h_purcharse_day_per.splice(index,1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		// 新增订单范围
		hcAddCustom(){
			let obj = {
				id: 'c' + new Date().getTime(),
				h_min_money: 0, // 金额区间最小金额
				h_max_money: 0, // 金额区间最大金额
				h_order_per: [{ // 下单回传比率数组
					id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
					value: 0
				}],
				
				h_purcharse_day_per: [{ // 付费次日-30日回传比率数组
					id: 'f1',
					value: 0
				}],
			}
			this.hCustomData.push(obj)
		},
		// 删除新增订单范围
		hcDelCustom(indd){
			if(this.hCustomData.length > 1){
				this.hCustomData.splice(indd,1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		
		// 表格内的操作按钮
		tdHandle(e,item){
			console.log("表格内的操作按钮",e,item)
			this.h_plan_name = item.plan_name
			this.h_plan_id = item.plan_id
			if(e == 8){ // 小时数据
				// 控制子组件的事件
				this.$refs.getDrawerHour.getTableData(item.plan_id)
			}
			else if(e == 9){ // 天数据
				this.$refs.getDrawerDay.getTableData(item.plan_id)
			}
		},
		// 获取小时数据的加载状态控制
		hourLoadingHandle(e){
			console.log("获取小时数据的加载状态控制",e)
			this.search_button_loading = e
		},
		// 获取小时数据侧边栏关闭
		hourDrawerClose(e){
			this.h_plan_name = ""
			this.h_plan_id = ""
		},
		
		
		// 自定义列
		// 数据项————————
		onChangeSJ(e,index,d_tem){
			this.rableTitle[index].show_control = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
			// 重新计算表格宽度
			this.computeTableWidth()
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			d_tem.showTitle.forEach(res=>{
				this.rableTitle.forEach(t_es=>{
					if(res == t_es.type && !t_es.show_control){ // 表示有勾选
						ccccc = false
					}
				})
			})
			d_tem.custom_checkbox = ccccc
		},
		// 自定义列的小标题前的选择框
		checkboxCustom(e,d_tem){
			d_tem.custom_checkbox = e.target.checked
			
			this.rableTitle.forEach(res=>{
				d_tem.showTitle.forEach(d_es=>{
					if(res.type == d_es){
						if(e.target.checked){ // 要进行选中
							res.show_control = true
						}
						else {
							res.show_control = false
						}
					}
				})
			})
			// 重新计算表格宽度
			this.computeTableWidth()
		},
		// 自定义列弹窗确认按钮
		customTd(){
			let s_data = []
			this.rableTitle.forEach(res=>{
				let obj = {
					type: res.type,
					show_control: res.show_control
				}
				s_data.push(obj)
			})
			localStorage.setItem("table_custtom_JLjh",JSON.stringify(s_data));
			this.custtom_visible = false
		},
		// 计算表格宽度
		computeTableWidth(){
			let that = this
			let ttt = JSON.parse(JSON.stringify(that.rableTitle))
			
			// 获取表格信息
			let table_info = this.$getTableInfo(ttt, 60)
			that.body_width = table_info.body_width
			that.table_scroll_width = table_info.table_width
			that.table_null_width = table_info.null_width
			
			that.$nextTick(()=>{
				// 给母页面的tab传递粘性定位用的参数
				that.$bus.$emit("stickyData", that.table_scroll_width);
			})
			
		},
	},
	filters: {
		dayToFixed(e){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",e)
			if(Object.keys(e).length > 0){
				if(e.charge_money){ // 有时候charge_money字段的值为null
					let v = (Number(e.charge_money)/Number(e.cost))*1.06*100
					return v.toFixed(2)
				}
				else {
					return '-'
				}
				
			}
			else {
				return '-'
			}
			
		}
	}
}
</script>

<style scoped>
.day-data-a {
	font-size: 16px;
	font-weight: 800;
}
.day-data-b {
	font-size: 13px;
}
.day-data-c {
	font-size: 13px;
	margin-top: 5px;
}
.day-data-e {
	display: flex;
	align-items: flex-end;
}

/* 侧边栏样式 */
.form-cell-box {
	margin-bottom: 20px;
}
.class-title {
	width: 115px;
}

/* 自定义列 */
.custom-title {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.custom-cell-box {
	display:flex;
	flex-wrap: wrap;
	padding-left: 20px;
	margin-bottom:20px;
}
</style>